import {
	EASTER_EGGS_LOADING,
	EASTER_EGGS_SUCCESS,
	EASTER_EGGS_FAILURE,
	USER_EASTER_EGGS_LOADING,
	USER_EASTER_EGGS_LOADING_SUCCESS,
	USER_EASTER_EGGS_LOADING_FAILURE,
	POST_EASTER_EGG_FOUND_SUCCESS,
	POST_EASTER_EGG_FOUND_FAILURE,
	AM_I_MASTER_EGG_HUNTER_SUCCESS,
	AM_I_MASTER_EGG_HUNTER_FAILURE,
	MASTER_EGG_HUNTERS_LOADING,
	GET_MASTER_EGG_HUNTERS_SUCCESS,
	GET_MASTER_EGG_HUNTERS_FAILURE,
	CLEAR_AM_I_MASTER_EGG_HUNTER,
} from 'redux/reduxConstants';
import { EasterEgg } from 'redux/models/easterEgg';
import { EggHunter } from 'redux/models/eggHunter';
import { UserEgg } from 'redux/models/userEgg';
interface EasterEggState {
	userEggs: UserEgg[];
	easterEggs: EasterEgg[];
	eggHunters: EggHunter[];
	loadingEggHunters: boolean;
	loadingEasterEggs: boolean;
	loadingUserEasterEggs: boolean;
	amIMasterEggHunter: boolean;
	error: string;
}

const easterEggState: EasterEggState = {
	userEggs: [],
	easterEggs: [],
	eggHunters: [],
	loadingEggHunters: false,
	loadingEasterEggs: false,
	loadingUserEasterEggs: false,
	amIMasterEggHunter: false,
	error: '',
};

const easterEggs = (state = easterEggState, action: any) => {
	switch (action.type) {
		case EASTER_EGGS_LOADING:
			let easterEggState = { ...state };
			easterEggState.loadingEasterEggs = true;
			return easterEggState;

		case EASTER_EGGS_SUCCESS:
			let easterEggSuccessState = { ...state };
			easterEggSuccessState.loadingEasterEggs = false;
			easterEggSuccessState.easterEggs = action.easterEgg.value;
			return easterEggSuccessState;

		case EASTER_EGGS_FAILURE:
			let easterEggFailureState = { ...state };
			easterEggFailureState.loadingEasterEggs = false;
			easterEggFailureState.error = action.error;
			return easterEggFailureState;

		case USER_EASTER_EGGS_LOADING:
			let easterEggUserState = { ...state };
			easterEggUserState.loadingUserEasterEggs = true;
			return easterEggUserState;

		case USER_EASTER_EGGS_LOADING_SUCCESS:
			let easterEggUserSuccessState = { ...state };
			easterEggUserSuccessState.loadingUserEasterEggs = false;
			easterEggUserSuccessState.userEggs = action.userEgg.value;
			return easterEggUserSuccessState;

		case USER_EASTER_EGGS_LOADING_FAILURE:
			let easterEggUserFailureState = { ...state };
			easterEggUserFailureState.loadingUserEasterEggs = false;
			easterEggUserFailureState.error = action.error;
			return easterEggUserFailureState;

		case POST_EASTER_EGG_FOUND_SUCCESS:
			let postEasterEggFoundSuccessState = { ...state };
			postEasterEggFoundSuccessState.userEggs.push(action.userEgg);
			return postEasterEggFoundSuccessState;

		case POST_EASTER_EGG_FOUND_FAILURE:
			let postEasterEggFoundFailureState = { ...state };
			postEasterEggFoundFailureState.error = action.error;
			return postEasterEggFoundFailureState;

		case AM_I_MASTER_EGG_HUNTER_SUCCESS:
			let getAmIMasterEggHunterSuccessState = { ...state };
			let boolValue = JSON.parse(action.isMasterEggHunter.toLowerCase());
			getAmIMasterEggHunterSuccessState.amIMasterEggHunter = boolValue;
			return getAmIMasterEggHunterSuccessState;

		case AM_I_MASTER_EGG_HUNTER_FAILURE:
			let getAmIMasterEggHunterFailureState = { ...state };
			getAmIMasterEggHunterFailureState.error = action.error;
			return getAmIMasterEggHunterFailureState;

		case MASTER_EGG_HUNTERS_LOADING:
			let masterHunterState = { ...state };
			masterHunterState.loadingEggHunters = true;
			return masterHunterState;

		case GET_MASTER_EGG_HUNTERS_SUCCESS:
			let eggHunterSuccessState = { ...state };
			eggHunterSuccessState.loadingEggHunters = false;
			eggHunterSuccessState.eggHunters = action.masterEggHunters.value;
			return eggHunterSuccessState;

		case GET_MASTER_EGG_HUNTERS_FAILURE:
			let eggHunterFailureState = { ...state };
			eggHunterFailureState.loadingEggHunters = false;
			eggHunterFailureState.error = action.error;
			return eggHunterFailureState;

		case CLEAR_AM_I_MASTER_EGG_HUNTER:
			let cleartAmIMasterEggHunterState = { ...state };
			cleartAmIMasterEggHunterState.amIMasterEggHunter = false;
			return cleartAmIMasterEggHunterState;

		default:
			return state;
	}
};

export default easterEggs;
